/**
 * The three animated service heroes on the landing page (Car Care, Home Care, Appliance Repair).
 * Edit the words here; pictures live in /public/media/hero/. `book` is where the required "Book Now" button goes:
 *   "/path" -> opens that page,   "#section-id" -> scrolls to that section of the landing page.
 * `focus`: "car" shows the car plans; "home" shows the home services and HIDES the car plans.
 * `pick`: the home-service card to highlight (a type from UPCOMING_SERVICES).
 */
export const SERVICE_HEROES = [
  {
    key: "car", tab: "Car Care", kicker: "Car care · at your doorstep",
    lines: [["Come", "home", "to"], ["a", "car", "that", "glows."]], accentFrom: 1,
    quote: "Not a rushed roadside rinse. A careful wash, right where you park.",
    from: { label: "Roadside wash", text: "Queue, drive, wait" }, to: { label: "Navi Care", text: "Book, relax, shine" },
    book: "#plans", focus: "car", pick: "",
    image: "/media/hero/car-care", alt: "NAVI CARE doorstep car wash: foam wash, deep vacuum, steam wash, AC duct clean and ceramic coat",
  },
  {
    key: "home", tab: "Home Care", kicker: "Home care · room by room",
    lines: [["A", "home", "that"], ["feels", "new", "again."]], accentFrom: 1,
    quote: "Not a hurried wipe-down. A deep, room-by-room reset you can feel.",
    from: { label: "Quick clean", text: "Surfaces only" }, to: { label: "Navi Care", text: "Every corner, properly" },
    book: "#upcoming-services", focus: "home", pick: "house_deep_cleaning",
    image: "/media/hero/home-care", alt: "NAVI CARE home care: kitchen, TV stand, sofa and carpet deep cleaning",
  },
  {
    key: "appliance", tab: "Appliance Repair", kicker: "Appliance care · AC to TV",
    lines: [["Fixed", "right."], ["No", "runaround."]], accentFrom: 1,
    quote: "Not days of phone calls. One booking, one technician, price confirmed first.",
    from: { label: "Chasing technicians", text: "Calls, delays, surprises" }, to: { label: "Navi Care", text: "One booking, clear price" },
    book: "#upcoming-services", focus: "home", pick: "appliance_repair_installation",
    image: "/media/hero/appliance-care", alt: "NAVI CARE appliance repair: AC, washing machine, refrigerator, microwave and TV",
  },
];
